import React from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Col, Divider, Row, Spin, Typography } from 'antd'
import ArtworkCollectionsPanel from '../../component/collection/ArtworkCollectionsPanel'
import { URL_NEW_COLLECTIONS } from '../../const'
import AddPrimaryButton from '../../component/base/AddPrimaryButton'

const { Title } = Typography

@connect((state) => ({
  //decorator, gives component access to the state
  userId: state.user.info.id,
  artistId: state.user.info.artistId,
  email: state.user.info.email,
  role: state.user.info.role
}))
class Collections extends React.Component {
  constructor(props) {
    super(props)
    this.query = new URLSearchParams(this.props.location.search)
    this.state = {
      dataSource: [],
      pageSize: 4,
      current: this.query.get('page'),
      total: 0,
      showImage: true
    }
  }

  render() {
    return (
        <div className='site-layout-background'>
          <ArtworkCollectionsPanel />
        </div>
    )
  }
}

export default withRouter(Collections)
